import {
  ControlcenterMelcoModelsSupplierProduct,
  SuppliersApi,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { ALL_PUBLISHED_STATES } from "../../helper/publishedState";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const useManageSupplierProducts = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQueryChange,
    searchQuery,
  } = useTable<ControlcenterMelcoModelsSupplierProduct>({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  const query = useAPIQuery(
    SuppliersApi,
    [
      "managesuppliersproducts",
      searchQuery,
      currentPage,
      pageSize,
      filters,
      sortBy(),
    ],
    async (api) => {
      //const api = new ControlCenterApi(baseApiConfig({ token }));

      let response = await api.supplierProductsSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : "",

        publishState: ALL_PUBLISHED_STATES,
      });

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQueryChange,
    errorComponent,
    searchQuery,
    ...query,
  };
};
